module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "saml-form"
  }, [_c('loading', {
    attrs: {
      "isLoading": _vm.isLoading
    },
    on: {
      "reset": _vm.reload
    }
  }), (!_vm.isLoading) ? _c('div', {
    staticClass: "content"
  }, [_c('page-header', {
    attrs: {
      "title": "Single Sign On",
      "subTitle": "Log in and let's get productive!",
      "error": _vm.formError
    }
  }), _c('form', {
    staticClass: "w-login-form w-login-form--sso",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "w-login-form__row w-login-form__row--email"
  }, [_c('div', {
    staticClass: "w-input"
  }, [_c('label', {
    staticClass: "w-input__label",
    attrs: {
      "for": "loginemail"
    }
  }, [_vm._v("Email address")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "w-input__input",
    attrs: {
      "id": "loginemail",
      "type": "email",
      "placehoder": "",
      "autocomplete": "username",
      "required": "required"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })])]), _c('div', {
    staticClass: "w-login-form__row w-login-form__row--action"
  }, [_c('button', {
    staticClass: "w-button",
    class: {
      'w-button--gray': !_vm.canSubmit, 'w-button--blue': _vm.canSubmit
    },
    attrs: {
      "type": "submit",
      "disabled": !_vm.canSubmit
    }
  }, [_c('span', {
    staticClass: "w-button__label"
  }, [_vm._v("Log in")])])])]), _c('div', {
    staticClass: "w-page-footer"
  }, [_c('button', {
    staticClass: "w-button w-button--link",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$store.commit('setLoginState', 'standard')
      }
    }
  }, [_c('span', {
    staticClass: "w-button__label"
  }, [_vm._v("Return to login")])])])], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c93d4d32","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sections/Login/SAMLForm/SAMLForm.vue
// module id = 613
// module chunks = 1